module.exports = __webpack_public_path__ + "img/Ausblick.ae31150a.jpg";